<template>
	<div class="admin-main">
		<div class="admin-top flex-rcc">
			微信小程序信息
		</div>
		<van-form validate-first @submit="onSubmit" class="form-box">
			<div class="field-box">
				<van-field v-model="registration" registration="card" label="法人姓名：" placeholder="请输入法人姓名" :rules="[{ required: true, message: '请输入法人姓名' }]"></van-field>
				<div class="remind">必须是个体户或者企业营业执照上的法人姓名</div>
			</div>
			<div class="field-box">
				<van-field v-model="registration" registration="card" label="法人微信号  ：" placeholder="请输入法人微信号" :rules="[{ required: true, message: '请输入法人微信号' }]"></van-field>
				<div class="remind">必须是个体户或者企业营业执照上的法人的微信号</div>
			</div>
			<div class="field-box">
				<van-field v-model="registration" registration="card" label="小程序的名称：" placeholder="请输入法人姓名" :rules="[{ required: true, message: '请输入法人姓名' }]"></van-field>
				<div class="remind">建议用品牌名字，避免冲突</div>
			</div>
			<div class="field-box">
				<van-field name="uploader" label="小程序的logo：">
					<template #input>
						<van-uploader v-model="uploader" :max-count="1"></van-uploader>
					</template>
				</van-field>
			</div>
			<div class="field-box">
				<van-field v-model="message" rows="4"
						autosize
						label="小程序的简介："
						type="textarea"
						maxlength="150"
						placeholder="请输入小程序的简介"
						show-word-limit>
				</van-field>
			</div>
			<div class="bottom-bar-placeholder"></div>
			<div class="admin-bottom-bar">
				<van-button native-type="submit" class="button-default" :class="isApp === 'isWeixin' ? 'wx-button-primary' : 'zfb-button-primary'" >
					下一步
				</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    name: "index",
		data () {
      return{
        radiod: 0,
        uploader: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }],
        services: '',
        registration: '',
        name: '',
        message: ''
			}
		},
    computed: {
      ...mapState(['isApp', 'openId'])
    },
    created () {
    },
    methods: {
			next () {},
      onSubmit(values) {
        console.log('submit', values)
      }
    }
  };
</script>

<style scoped lang="stylus">
	.van-cell
		padding 5px 2px !important
		&:after
			border none !important
			border-bottom 0 !important
</style>
